module.exports = __webpack_public_path__ + "img/homepage-desk.d480e4ea.jpg";